import { render } from "./vcoursewareclassify.vue?vue&type=template&id=c97faaba&scoped=true"
import script from "./vcoursewareclassify.vue?vue&type=script&lang=js"
export * from "./vcoursewareclassify.vue?vue&type=script&lang=js"

import "./vcoursewareclassify.vue?vue&type=style&index=0&id=c97faaba&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c97faaba"]])

export default __exports__